import React, {Component} from "react";

import { IS_VALID }       from "utils";

import Create             from "./Create";

export default class FormContainer extends Component {
    render () {
        let {
            actions,

            selectedData,
            formType
        } = this.props;

        let createProps = {
            actions
        };

        switch (formType.toUpperCase()) {
            case "UPDATE":
            case "CREATE":
                return <Create {...createProps} />;
                break;
            case "DELETE":
                return (
                    <p>
                      Are you sure you want to delete&nbsp;
                      {IS_VALID(selectedData) && IS_VALID(selectedData.get("uuid")) ? (
                        <span style={{ color: "red" }}>{selectedData.get("uuid")}</span>
                      ) : (
                        "this data"
                      )}
                      ?
                    </p>
                );
                break;
            default:
                return "";
                break;
        }
    }

    componentWillUnmount () {
        let {
            actions
        } = this.props;

        actions.setValue({
            selectedData: null,
            formType: "",
            formId: "",
            formTitle: "",

            uuid: "",
            major: "",
            minor: "",
            hexNamespace: "",
            hexInstance: ""
        });
    }
}


// WEBPACK FOOTER //
// ./components/Beacon/FormContainer/index.js